import { render, staticRenderFns } from "./MigrateWarrants.vue?vue&type=template&id=4a2a9405&scoped=true"
import script from "./MigrateWarrants.vue?vue&type=script&lang=js"
export * from "./MigrateWarrants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2a9405",
  null
  
)

export default component.exports